import type { ReactNode } from 'react';

type Props = {
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
};

// Page-header pattern used across every hub page: small uppercase
// eyebrow, confident title, muted subtitle, optional actions cluster
// on the right. Pulled into its own component so the rhythm stays
// consistent and future hub pages drop into the same look for free.
export function HubPageHeader({ eyebrow, title, subtitle, actions }: Props) {
  return (
    <header className="flex items-start gap-4">
      <div className="flex-1 min-w-0">
        {eyebrow ? (
          <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-text-subtle">
            {eyebrow}
          </div>
        ) : null}
        <h1 className="text-[26px] leading-tight font-semibold text-text-strong mt-1">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-sm text-text-muted mt-1.5">{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
    </header>
  );
}

// Reusable section-title eyebrow for content blocks under the header.
export function HubSectionTitle({ children }: { children: ReactNode }) {
  return (
    <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-text-subtle">
      {children}
    </div>
  );
}
